(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-redirect"]) return;
  try {
    
  (() => {
    const cartRedirect = document.querySelector('[data-cart-redirect-url]');

    if (!cartRedirect) {
      return;
    }

    const cartRedirectUrl = cartRedirect.dataset.cartRedirectUrl;

    if (!cartRedirectUrl) {
      return;
    }

    window.location.replace(cartRedirectUrl);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gateway"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gatewayLocalizationForm = document.getElementById('GatewayLocalizationForm');

    if (!gatewayLocalizationForm) {
      return;
    }

    const gatewayCountryRegionLanguageSelector = gatewayLocalizationForm.querySelector('[data-country-region-language-selector]');
    const gatewayCountryInput = gatewayLocalizationForm.querySelector('[name="country_code"]');
    const gatewayLanguageInput = gatewayLocalizationForm.querySelector('[name="language_code"]');

    if (!gatewayCountryRegionLanguageSelector || !gatewayCountryInput || !gatewayLanguageInput) {
      return;
    }

    const syncGatewayLocalizationInputs = () => {
      const selectedOption = gatewayCountryRegionLanguageSelector.options[gatewayCountryRegionLanguageSelector.selectedIndex];

      if (!selectedOption) {
        return;
      }

      gatewayCountryInput.value = selectedOption.dataset.countryCode;
      gatewayLanguageInput.value = selectedOption.dataset.languageCode;
    };

    syncGatewayLocalizationInputs();

    gatewayCountryRegionLanguageSelector.addEventListener('change', () => {
      syncGatewayLocalizationInputs();
      gatewayLocalizationForm.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
